<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { onMounted, ref } from "vue";
import { gsap } from "@/vendor/gsap";
import { ScrollTrigger } from "@/vendor/gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const el = ref(null);
onMounted(() => {
    const section = el.value.closest('.section-sdg17');
    const goals = section.querySelector('.section-sdg17__goals');
    ScrollTrigger.create({
        trigger: goals,
        start: "top center",
        onEnter: () => {
            section.classList.add('section-sdg17--active');
        }
    });
});

</script>

<template>
    <div ref="el">
        <slot />
    </div>
</template>
